import React from 'react'
import { Link } from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChartLine,
  faCubes,
  faCube
} from '@fortawesome/free-solid-svg-icons'
import './index.scss'

const FurtherInterests = () => {
  return (
    <div className="further-interests">
      <div className="further-interests__headline headline headline--centered">
        <h2>Das könnte Sie auch interessiern:</h2>
      </div>
      <div className="further-interests__container">
        <div className="further-interests__item">
          <Link to="#">
            <div className="further-interests__content">
              <h4>Digitaler Reifegrad</h4>
              <ul>
                <li>
                  <FontAwesomeIcon icon={faChartLine} /> Mit Auswertung
                </li>
              </ul>
            </div>
          </Link>
        </div>
        <div className="further-interests__item">
          <Link to="#">
            <div className="further-interests__content">
              <h4>
                Beratungs
                <br />
                pakete
              </h4>
              <ul>
                <li>
                  <FontAwesomeIcon icon={faCubes} /> Let's talk about ..
                </li>
              </ul>
            </div>
          </Link>
        </div>
        {/* <div className="further-interests__item">
          <Link to="#">
            <div className="further-interests__content">
              <h4>Checkliste DSGVO</h4>
              <ul>
                <li><FontAwesomeIcon icon={faDownload} /> Schneller Download</li>
              </ul>
            </div>
          </Link>
        </div> */}
        <div className="further-interests__item">
          <Link to="#">
            <div className="further-interests__content">
              <h4>
                Beratung zu <br />
                digitalen Förderungen
              </h4>
              <ul>
                <li>
                  <FontAwesomeIcon icon={faCube} /> Tiroler Beratungsförderung
                </li>
                <li>
                  <FontAwesomeIcon icon={faCube} /> Digitalisierungsförderung
                </li>
                <li>
                  <FontAwesomeIcon icon={faCube} /> Tiroler Innovationsförderung
                </li>
                <li>
                  <FontAwesomeIcon icon={faCube} /> EPU Kooperationsförderung
                </li>
              </ul>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default FurtherInterests
